/* This file is autogenerated, see readme.md for instructions */
import SettingsAltSvgIcon from '@bloomreach/banana-theme/icons/settings-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SettingsAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SettingsAltSvgIcon />
    </Icon>
  );
});

SettingsAltIcon.displayName = 'SettingsAltIcon';

export default SettingsAltIcon;
